import {CSSProperties, FC} from 'react';


export interface IIconAbsBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconAbsBmw: FC<IIconAbsBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M3.001 12c0-4.963 4.038-9 9-9s9 4.037 9 9-4.038 9-9 9-9-4.037-9-9Zm6.335 2.47a.573.573 0 0 0 .545-.74L8.74 10.046a.724.724 0 0 0-.691-.51h-.395c-.318 0-.599.209-.692.513l-1.14 3.73a.534.534 0 0 0 .51.69.571.571 0 0 0 .551-.418l.236-.848H8.53l.259.86a.571.571 0 0 0 .547.406Zm2.643.051c.981 0 1.581-.16 1.94-.446.307-.25.512-.6.512-1.047 0-.636-.417-1.06-.98-1.215V11.8c.556-.205.812-.615.812-1.054 0-.446-.25-.783-.593-.966-.359-.212-.776-.278-1.456-.278-.439 0-.9.027-1.22.067a.255.255 0 0 0-.222.253v4.402c0 .13.098.24.228.253.245.025.574.045.98.045Zm3.45-.113c.278.079.624.135.973.135 1.354 0 1.99-.702 1.99-1.53 0-.694-.41-1.148-1.28-1.47-.637-.242-.915-.38-.915-.695 0-.257.234-.476.717-.476.234 0 .437.032.606.077.243.063.491-.08.558-.321l.008-.029a.438.438 0 0 0-.312-.54 3.32 3.32 0 0 0-.838-.102c-1.163 0-1.866.644-1.866 1.486 0 .717.534 1.17 1.354 1.456.593.212.827.388.827.695 0 .322-.271.534-.784.534-.28 0-.555-.053-.796-.129a.441.441 0 0 0-.562.317l-.007.03a.467.467 0 0 0 .326.562Zm-3.077-4.095c.505 0 .79.198.79.57 0 .367-.314.608-.9.608h-.366v-1.149c.096-.014.234-.03.476-.03Zm-.476 1.976h.38c.557 0 1.003.198 1.003.695 0 .52-.446.71-.95.71-.191 0-.323 0-.433-.015v-1.39Zm-4.003-1.673a.062.062 0 0 0-.12 0c-.055.22-.134.534-.183.707l-.292 1.047h1.09l-.307-1.047c-.065-.215-.13-.47-.188-.707Z" clipRule="evenodd" />
        </svg>
    );
};
